import { Player, useGameContext } from "GameContext";

import {
    useState,
    useEffect,
} from "react";

import { getRoleConstants } from "utils/game-information-constants";

export default function PublicHunter() {
    return (
        <div>
            <p>Hunt data</p>
            <br />
            <br />
            <p>Amount hunted may differ due to variability</p>

            <ul className="list-disc list-inside mt-2">
                <li>If the hunting bag is 100 or less → profit is 500.</li>
                <li>If the hunting bag is greater than 100 but not more than 150 → profit is 800.</li>
                <li>If the hunting bag is greater than 150 → profit is 1200.</li>
                <li>If none of these conditions are met → profit is 0.</li>
            </ul>
            <br />
        </div>
    )

}
